import { useEffect } from 'react';

// Hooks
import useUser from '@/utils/hooks/swr/useUser';

// Utils
import { getLocalStorageTheme, setLocalStorageTheme } from '@/utils/localStorage/themeLocalStorage';

//Types
import { ThemeType } from '@/types/userType';

const useDarkMode = () => {
    //Bool that return if current mode is dark
    const isDarkMode = () => {
        if (typeof window === 'undefined') {
            return;
        }

        return document.querySelector('html').classList.contains('dark');
    };

    //Remove dark class from html tag to disabled darkmode
    const useRemoveDarkMode = () => {
        useEffect(() => {
            if (!document.querySelector('html').classList.contains('dark')) {
                return;
            } else {
                document.querySelector('html').classList.remove('dark');
            }
        }, []);
    };

    //Makes sure that the right theme is used
    const useAddDarkMode = () => {
        const { user } = useUser({ revalidateOnMount: false, revalidateOnFocus: false });

        useEffect(() => {
            const localStorageTheme = getLocalStorageTheme();

            if (user && localStorageTheme && user?.settings?.theme !== localStorageTheme) {
                setLocalStorageTheme(user?.settings?.theme);
                if (user?.settings?.theme === 'dark') {
                    document.querySelector('html').classList.add('dark');
                } else {
                    document.querySelector('html').classList.remove('dark');
                }
            } else if (
                localStorageTheme &&
                localStorageTheme === 'dark' &&
                !document.querySelector('html').classList.contains('dark')
            ) {
                document.querySelector('html').classList.add('dark');
            } else if (
                localStorageTheme !== 'dark' &&
                document.querySelector('html').classList.contains('dark')
            ) {
                document.querySelector('html').classList.remove('dark');
            }
            //use user settings if local storage have been cleared/other computer or icognito mode
            else if (
                user &&
                user?.settings?.theme === 'dark' &&
                !document.querySelector('html').classList.contains('dark')
            ) {
                setLocalStorageTheme('dark');
                document.querySelector('html').classList.add('dark');
            }
        }, [user?.settings?.theme]);
    };

    //Toggle theme between light && dark
    const toggleDarkMode = (theme: ThemeType) => {
        if (theme === 'light' && document.querySelector('html').classList.contains('dark')) {
            document.querySelector('html').classList.remove('dark');
        } else if (theme === 'dark' && !document.querySelector('html').classList.contains('dark')) {
            document.querySelector('html').classList.add('dark');
        }
    };

    return { useAddDarkMode, useRemoveDarkMode, toggleDarkMode, isDarkMode };
};

export default useDarkMode;
